import React from "react";

export function initialsOf(name) {
  const words = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length === 0) return "";
  if (words.length === 1) return words[0][0];
  return `${words[0][0]}${words[1][0]}`;
}

export function hueOf(name) {
  let sum = 0;
  for (const ch of String(name || "")) {
    sum += ch.charCodeAt(0);
  }
  return (sum * 37) % 360;
}

export default function Avatar({ name, size = 32 }) {
  const sizeClass = size === 44 ? " vs-avatar--lg" : size === 18 ? " vs-avatar--sm" : "";
  return (
    <span
      className={`vs-avatar${sizeClass}`}
      style={{ "--avatar-hue": hueOf(name) }}
      aria-hidden="true"
    >
      {initialsOf(name)}
    </span>
  );
}
